// Imported first so OAuth error params are captured from the callback URL
// before App's `Amplify.configure()` strips them. Keep this above ./App.
import "./helpers/oauthError";
import React from "react";
import ReactDOM from "react-dom";
import {createBrowserHistory} from "history";
import {Router} from "react-router";
import { GoogleOAuthProvider } from "@react-oauth/google";
import "bootstrap/dist/css/bootstrap.css";
import "./index.css";
import * as serviceWorker from "./serviceWorker";
import App from "./App";
import {AuthProvider} from "./routes/login/AuthContext";
import { GOOGLE_CLIENT_ID } from "./constants/general";

const history = createBrowserHistory();

ReactDOM.render(
  <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
    <Router history={history}>
      <AuthProvider>
        <App/>
      </AuthProvider>
    </Router>
  </GoogleOAuthProvider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
